export const buildMotionProps = (delay = 0, margin = '-100px') => ({
  initial: 'initial',
  whileInView: 'animate',
  viewport: { once: true, margin },
  exit: 'exit',
  transition: {
    delay,
    duration: 0.5,
    ease: 'easeInOut',
  },
  variants: {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
    },
  },
});

export const defaultMotionProps = buildMotionProps();
